import { IRandom } from './IRandom.js'

export class Random implements IRandom {
  next(): number {
    return Math.random()
  }

  nextInt(_min: number, _max: number): number {
    const min = Math.ceil(_min)
    const max = Math.floor(_max)
    return Math.floor(this.next() * (max - min + 1)) + min
  }
}
